import React, { Component } from 'react';
import Scroll from 'react-scroll';
import './App.css';

import { Footer, Banner, HeaderMenu, ProductComponents, FeatureList, SocialWall, PlatformList } from './common';

const Element = Scroll.Element;
const scroll = Scroll.scroller;

class App extends Component {

  state = { modalIsOpen: false }

  toggleModal() {
    this.setState({ modalIsOpen: !this.state.modalIsOpen });
  }
  scrollToSocialWall() {
    scroll.scrollTo('socialWall', { smooth: true });
  }

  renderHeaderMenu() {
    if (this.state.modalIsOpen) {
      return;
    }
    return <HeaderMenu scrollToSocialWall={this.scrollToSocialWall.bind(this)} />;
  }

  render() {
    return (
      <div className="App">
        {/*this.renderHeaderMenu()*/}
        <Banner scrollToSocialWall={this.scrollToSocialWall.bind(this)} />
        <ProductComponents Components={Components.slice(0,3)} />
        <FeatureList />
        <ProductComponents Components={Components.slice(3,6)} />
        <Footer />
      </div>
    );
  }
}


const Components = [
  {
    icon: 'share-alt',
    title: 'Social',
    summary: 'Share your ideas, investments and private deals with the people you trust most. With a trusted social investment circle will be best positioned to help each other build a robust portfolio and a bright future'
  },
  {
    icon: 'users',
    title: 'Follow the experts',
    summary: 'Follow savvy friends or successful investors. Get accessto their investment portfolio and ideas...and replicate their success!'
  },
  {
    icon: 'pie-chart',
    title: 'Deals you can trust',
    summary: 'Most of us do not have the time, the interest or the knowledge to look at complex but lucrative investments or source them. By tapping into the wisdom of your circles, investment possibilities become infinite.'
  },
  {
    icon: 'cubes',
    title: 'All asset classes',
    summary: 'A diversified stock portfolio is still 100% linked to only one asset class: The stock market. See how real successful investors diversify their risk and increase their return. Get insight into real-estate, startups, lending and private deals.'
  },
  {
    icon: 'user-circle',
    title: 'All type of investors',
    summary: 'Either you are a seasoned investors, or a newbie, for each asset class you can find your pick, from do it on my own to hands off investing.'
  },
  {
    icon: 'institution',
    title: 'All Platforms',
    summary: 'Each platform just looks at one asset class. Here, you can do it all in one site. We help you pick the best robot advisor, or crowdfunding platform'
  },
]; 

export default App;



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/